__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/phx-rel-r26.1.2-01122026/_next/";